import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'thousandSeparator',
    standalone: true
})
export class ThousandSeparatorPipe implements PipeTransform {

	transform(value: number): string {
		const parts: Array<string> = value.toString().split('.'),
			integerPart: string = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

		if (parts.length === 2) {
			return integerPart + '.' + parts[1];
		} else {
			return integerPart;
		}
	}
}